package com.hyperether.goodjob.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import kotlinx.browser.window
import org.w3c.dom.events.Event

@Composable
actual fun getPlatformScale(): Float {
    val initialWidth = window.innerWidth.toFloat()
    val screenWidth = remember { mutableStateOf(initialWidth) }

    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            screenWidth.value = window.innerWidth.toFloat()
        }

        window.addEventListener("resize", listener)

        onDispose {
            window.removeEventListener("resize", listener)
        }
    }

    return rememberScaleFromScreenWidthPx(screenWidth.value)
}

@Composable
private fun rememberScaleFromScreenWidthPx(screenWidthPx: Float): Float = remember(screenWidthPx) {
    when {
        screenWidthPx <= 1280f -> 0.95f       // HD
        screenWidthPx <= 1600f -> 1.0f
        else -> 1.05f                       // Full HD +
    }
}